import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { VatFilterProps } from '../../types';

const variantsFilter = ['success', 'danger'] as const;

const VatFilter = ({ vat, setVat }: VatFilterProps) => {
    const { t } = useTranslation(['Reports']);

    const variant = vat !== null ? variantsFilter[vat] : 'primary';

    return (
        <Dropdown>
            <Dropdown.Toggle
                className="me-1"
                size="sm"
                variant={variant}
                id="dropdown-basic"
                title={t('toolArchiveFilter')}
            >
                <i className="bi bi-funnel fs-14 p-0 me-1"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item as="button" onClick={() => setVat(null)}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={vat === null}
                            onChange={() => setVat(null)}
                        />
                        <a>{t('reportFilter.all')}</a>
                    </div>
                </Dropdown.Item>

                <Dropdown.Item as="button" onClick={() => setVat(0)}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={vat === 0}
                            onChange={() => setVat(0)}
                        />
                        {t('reportFilter.noVat')}
                    </div>
                </Dropdown.Item>

                <Dropdown.Item as="button" onClick={() => setVat(1)}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={vat === 1}
                            onChange={() => setVat(1)}
                        />
                        {t('reportFilter.withVat')}
                    </div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default VatFilter;
